import { useEffect } from "react";
import { posthog } from "@/instrument";
import { useSession } from "./use-session";

export function useIdentify() {
  const { data: user } = useSession();
  useEffect(() => {
    if (!user) return;
    try {
      posthog.identify(user.id, { email: user.email, isAdmin: user.isAdmin });
    } catch {
      // posthog not initialized; ignore.
    }
  }, [user]);
}
